import { isBoundary, mergeAdjacentText, } from "./template-render.js";
const MARKDOWN_MARKS = ['**', '__', '~~', '*', '_'];
const MARKDOWN_MARK_KIND = {
    '**': 'bold',
    __: 'bold',
    '~~': 'strike',
    '*': 'italic',
    _: 'italic',
};
/** Um bloco ``` … ``` inteiro, ou um trecho ` … ` numa linha. O molde é o `outsideCode` do gateway. */
const CODE_BLOCK = /(`{3}[\s\S]*?`{3})/;
const INLINE_CODE = /(`[^`\n]+`)/;
export const parseMarkdownText = (text) => {
    const spans = [];
    for (const part of text.split(CODE_BLOCK)) {
        if (part === '')
            continue;
        if (part.startsWith('```')) {
            spans.push({
                kind: 'mono',
                spans: [{ kind: 'code', text: part.slice(3, -3) }],
            });
            continue;
        }
        for (const piece of part.split(INLINE_CODE)) {
            if (piece === '')
                continue;
            if (piece.startsWith('`') && piece.endsWith('`')) {
                spans.push({ kind: 'code', text: piece.slice(1, -1) });
                continue;
            }
            spans.push(...parseMarkers(piece));
        }
    }
    return mergeAdjacentText(spans);
};
/**
 * A parte que roda FORA de qualquer código — mesma máquina de pilha de
 * `parseWhatsAppText`, com marcadores de um ou dois caracteres.
 */
const parseMarkers = (text) => {
    const root = [];
    const stack = [];
    const currentBuffer = () => stack[stack.length - 1]?.buffer ?? root;
    let i = 0;
    let literalRun = '';
    const flushLiteral = () => {
        if (literalRun === '')
            return;
        currentBuffer().push({ kind: 'text', text: literalRun });
        literalRun = '';
    };
    while (i < text.length) {
        const mark = MARKDOWN_MARKS.find((candidate) => text.startsWith(candidate, i));
        if (mark === undefined) {
            literalRun += text[i] ?? '';
            i += 1;
            continue;
        }
        const previous = i > 0 ? text[i - 1] : undefined;
        const next = i + mark.length < text.length ? text[i + mark.length] : undefined;
        const top = stack[stack.length - 1];
        // Fechar tem prioridade sobre abrir: `**a**` fecha no segundo par, em vez
        // de abrir uma segunda moldura que nunca fecharia.
        if (top?.mark === mark && isBoundary(next)) {
            flushLiteral();
            const frame = stack.pop();
            if (frame !== undefined) {
                currentBuffer().push({
                    kind: MARKDOWN_MARK_KIND[frame.mark],
                    spans: mergeAdjacentText(frame.buffer),
                });
            }
            i += mark.length;
            continue;
        }
        if (isBoundary(previous)) {
            flushLiteral();
            stack.push({ mark, buffer: [] });
            i += mark.length;
            continue;
        }
        // Nem fecha o topo, nem pode abrir: literal. É o caso de `2*3` e de
        // `relatorio_final`, que são texto e não formatação.
        literalRun += mark;
        i += mark.length;
    }
    flushLiteral();
    /*
     * Marcador sem par: a moldura aberta vira literal, e o que já foi
     * interpretado dentro dela sobe. Um `**` solto no fim de uma mensagem
     * aparece como `**`, que é o que a pessoa digitou.
     */
    while (stack.length > 0) {
        const frame = stack.pop();
        if (frame === undefined)
            continue;
        const parentBuffer = stack[stack.length - 1]?.buffer ?? root;
        parentBuffer.push({ kind: 'text', text: frame.mark });
        parentBuffer.push(...frame.buffer);
    }
    return root;
};
/**
 * O mesmo corpo, sem marcação nenhuma — para a prévia na lista do inbox
 * (F083).
 *
 * Construído sobre `parseMarkdownText` de propósito, e não com um punhado de
 * `replace`: a prévia e a bolha precisam concordar sobre o que é formatação e
 * o que é texto. Um `replace` que apagasse todo asterisco duplo comeria o
 * `2*3` de um orçamento e discordaria da bolha logo ao lado, que mostra `2*3`
 * corretamente.
 *
 * A quebra de linha vira espaço: a prévia é uma linha só, e o prefixo
 * `**Nome:**\n` das respostas ficaria com um buraco no meio sem isto.
 */
export const markdownToPlainText = (text) => spansToPlainText(parseMarkdownText(text))
    .replace(/\s*\n\s*/g, ' ')
    .trim();
const spansToPlainText = (spans) => spans
    .map((span) => {
    if (span.kind === 'text' || span.kind === 'code')
        return span.text;
    if (span.kind === 'placeholder')
        return `{{${String(span.index)}}}`;
    return spansToPlainText(span.spans);
})
    .join('');
//# sourceMappingURL=markdown-render.js.map